import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText, Mail, Phone } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const TermsOfServicePage = () => {
  const { t } = useLanguage();
  return (
    <div className="min-h-screen py-8 px-4" data-testid="terms-of-service-page">
      <div className="max-w-3xl mx-auto space-y-8">
        <div className="flex items-center gap-3">
          <Link to="/" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors">
            <ArrowLeft className="w-5 h-5" />
          </Link>
          <div>
            <div className="flex items-center gap-2">
              <FileText className="w-6 h-6 text-emerald-400" />
              <h1 className="text-2xl sm:text-3xl font-bold text-white">{t('terms.title')}</h1>
            </div>
            <p className="text-sm text-gray-400 mt-1">R.E.Mobiles (Resurrection Mobile) — {t('terms.edition')}</p>
          </div>
        </div>

        <div className="glass p-6 text-sm text-gray-300 leading-relaxed space-y-4">
          <p>
            {t('terms.introBefore')}{' '}
            <strong className="text-white">remobiles.com</strong>
            {t('terms.introMiddle')}{' '}
            <strong className="text-white">Resurrection Mobile (R.E.Mobiles)</strong>
            {t('terms.introAfter')}
          </p>
          <p>
            {t('terms.acceptIntro')}{' '}
            <Link to="/politique-confidentialite" className="text-cyan-400 hover:underline">{t('terms.privacyPolicy')}</Link>.
          </p>
          <h2 className="text-lg font-bold text-white pt-2">{t('terms.servicesTitle')}</h2>
          <p>{t('terms.servicesBody')}</p>
          <h2 className="text-lg font-bold text-white pt-2">{t('terms.pricingTitle')}</h2>
          <p>{t('terms.pricingBody')}</p>
          <h2 className="text-lg font-bold text-white pt-2">{t('terms.dataTitle')}</h2>
          <p>
            {t('terms.dataBefore')}{' '}
            <a href="mailto:contact@r-e-mobiles.com" className="text-cyan-400 hover:underline">contact@r-e-mobiles.com</a>
            {' '}{t('terms.dataAfter')}
          </p>
          <h2 className="text-lg font-bold text-white pt-2">{t('terms.contactTitle')}</h2>
          <p className="flex flex-wrap gap-4">
            <a href="mailto:contact@r-e-mobiles.com" className="inline-flex items-center gap-2 text-cyan-400"><Mail className="w-4 h-4" /> contact@r-e-mobiles.com</a>
            <span className="inline-flex items-center gap-2 text-gray-300"><Phone className="w-4 h-4 text-green-400" /> +594 694 27 40 51</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
